import { render, staticRenderFns } from "./PricingAlert.vue?vue&type=template&id=02c7aac2"
import script from "./PricingAlert.vue?vue&type=script&lang=js"
export * from "./PricingAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports